<script setup>
import { ref } from 'vue'
import { useTheme } from 'vuetify'

const drawer = ref(null)

const darkTheme = ref(false)
const theme = useTheme()

const changeTheme = () => {
  theme.global.name.value = darkTheme.value ? 'dark' : 'light'
}
</script>
<style>
html {
  /* https://stackoverflow.com/q/56973002 */
  overflow: visible;
}
</style>
<template>
  <v-app>
    <v-app-bar>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-app-bar-title>中国語単語帳</v-app-bar-title>

      <template v-slot:append>
        <v-switch
          v-model="darkTheme"
          @update:model-value="changeTheme"
          :prepend-icon="darkTheme ? 'mdi-weather-night' : 'mdi-weather-sunny'"
          hide-details
          inset
          class="mr-3"
        />
      </template>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer">
      <v-list>
        <v-list-item title="単語帳" href="/"></v-list-item>
        <v-list-item title="Question" href="question.html"></v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <wordlist/>
    </v-main>
  </v-app>
</template>

<script>
import wordlist from './components/wordlist.vue'

export default {
  name: 'App',

  components: {
    wordlist,
  },

  data: () => ({
    //
  }),
}
</script>